import React from 'react';
import { MonitorIcon, CodeIcon, ServerIcon, ArrowRightIcon, SearchIcon } from 'lucide-react';
import { NordenMascot } from './NordenMascot';
export function ServicesSection() {
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="diensten" className="relative py-24 lg:py-28 bg-white overflow-hidden" data-id="element-979">
      {/* Norden with laptop & gear — at work */}
      <div className="absolute -bottom-4 -left-4 lg:left-4 opacity-[0.08] pointer-events-none hidden md:block" data-id="element-980">
        <NordenMascot variant="laptop" size="xl" data-id="element-981" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-982">
        <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 text-center mb-4" data-id="element-983">
          Professioneel webdesign voor Alkmaarse ondernemers
        </h2>
        <p className="text-lg text-slate-600 text-center max-w-2xl mx-auto mb-12 lg:mb-16" data-id="element-984">
          Van strategie tot uitvoering. Wij zorgen voor een website die werkt.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-985">
          <a href="#/website-laten-maken" className="group border border-navy-100 rounded-card p-8 hover:shadow-medium hover:border-accent/20 transition-all duration-300 text-center md:text-left" data-id="element-986">
            <div className="w-14 h-14 rounded-xl bg-navy-50 group-hover:bg-accent-light flex items-center justify-center mb-6 transition-colors duration-300 mx-auto md:mx-0" data-id="element-987">
              <MonitorIcon className="w-7 h-7 text-navy-700 group-hover:text-accent transition-colors duration-300" data-id="element-988" />
            </div>
            <h3 className="text-xl font-semibold text-navy-900 mb-3" data-id="element-989">
              Website laten maken
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-990">
              Een professionele website laten maken in Alkmaar? Wij bouwen
              conversiegerichte websites die vertrouwen uitstralen en bezoekers
              omzetten in klanten.
            </p>
            <span className="inline-flex items-center gap-1.5 text-accent font-semibold text-sm group-hover:gap-2.5 transition-all" data-id="element-991">
              Meer info
              <ArrowRightIcon className="w-4 h-4" data-id="element-992" />
            </span>
          </a>

          <a href="#/seo-voor-websites" className="group border border-navy-100 rounded-card p-8 hover:shadow-medium hover:border-accent/20 transition-all duration-300 text-center md:text-left" data-id="element-993">
            <div className="w-14 h-14 rounded-xl bg-navy-50 group-hover:bg-accent-light flex items-center justify-center mb-6 transition-colors duration-300 mx-auto md:mx-0" data-id="element-994">
              <SearchIcon className="w-7 h-7 text-navy-700 group-hover:text-accent transition-colors duration-300" data-id="element-995" />
            </div>
            <h3 className="text-xl font-semibold text-navy-900 mb-3" data-id="element-996">
              SEO voor websites
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-997">
              Hoger scoren in Google en meer organisch verkeer? Wij
              optimaliseren jouw website voor zoekmachines met een bewezen SEO
              strategie.
            </p>
            <span className="inline-flex items-center gap-1.5 text-accent font-semibold text-sm group-hover:gap-2.5 transition-all" data-id="element-998">
              Meer info
              <ArrowRightIcon className="w-4 h-4" data-id="element-999" />
            </span>
          </a>

          <a href="#/wordpress-websites" className="group border border-navy-100 rounded-card p-8 hover:shadow-medium hover:border-accent/20 transition-all duration-300 text-center md:text-left" data-id="element-1000">
            <div className="w-14 h-14 rounded-xl bg-navy-50 group-hover:bg-accent-light flex items-center justify-center mb-6 transition-colors duration-300 mx-auto md:mx-0" data-id="element-1001">
              <CodeIcon className="w-7 h-7 text-navy-700 group-hover:text-accent transition-colors duration-300" data-id="element-1002" />
            </div>
            <h3 className="text-xl font-semibold text-navy-900 mb-3" data-id="element-1003">
              WordPress websites
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1004">
              Op zoek naar een WordPress website in Alkmaar? Wij bouwen snelle,
              veilige WordPress sites met SEO-optimalisatie en eenvoudig
              contentbeheer.
            </p>
            <span className="inline-flex items-center gap-1.5 text-accent font-semibold text-sm group-hover:gap-2.5 transition-all" data-id="element-1005">
              Meer info
              <ArrowRightIcon className="w-4 h-4" data-id="element-1006" />
            </span>
          </a>

          <a href="#/hosting-onderhoud" className="group border border-navy-100 rounded-card p-8 hover:shadow-medium hover:border-accent/20 transition-all duration-300 text-center md:text-left" data-id="element-1007">
            <div className="w-14 h-14 rounded-xl bg-navy-50 group-hover:bg-accent-light flex items-center justify-center mb-6 transition-colors duration-300 mx-auto md:mx-0" data-id="element-1008">
              <ServerIcon className="w-7 h-7 text-navy-700 group-hover:text-accent transition-colors duration-300" data-id="element-1009" />
            </div>
            <h3 className="text-xl font-semibold text-navy-900 mb-3" data-id="element-1010">
              Hosting & onderhoud
            </h3>
            <p className="text-slate-600 leading-relaxed mb-4" data-id="element-1011">
              Snelle, veilige hosting en zorgeloos technisch onderhoud. Wij
              houden jouw website up-to-date zodat jij je kunt focussen op
              ondernemen.
            </p>
            <span className="inline-flex items-center gap-1.5 text-accent font-semibold text-sm group-hover:gap-2.5 transition-all" data-id="element-1012">
              Meer info
              <ArrowRightIcon className="w-4 h-4" data-id="element-1013" />
            </span>
          </a>
        </div>

        <div className="mt-12 text-center" data-id="element-1014">
          <a href="#contact" onClick={scrollToContact} className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-semibold px-8 py-4 rounded-button shadow-medium hover:shadow-card transition-all duration-200 text-base group" data-id="element-1015">
            Vraag een vrijblijvend gesprek aan
            <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" data-id="element-1016" />
          </a>
        </div>
      </div>
    </section>;
}